module.exports = __webpack_public_path__ + "img/phone-177-circle-white.daff8d20.svg";